import React from 'react';
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";

interface DetailedResponse {
  title: string;
  content: string;
}

interface DetailedResponsePanelProps {
  currentDetailedResponse: DetailedResponse | undefined;
  currentCommandResponse: string;
  phase: 'showing' | 'processing' | 'complete' | 'typing';
  displayedDetailedText: string;
  isTypingDetailed: boolean;
}

const DetailedResponsePanel: React.FC<DetailedResponsePanelProps> = ({
  currentDetailedResponse,
  currentCommandResponse,
  phase,
  displayedDetailedText,
  isTypingDetailed
}) => {
  return (
    <Card className="border-l-4 border-l-accent w-full">
      <CardHeader className="pb-3">
        <h3 className="text-lg font-semibold text-foreground">
          {currentDetailedResponse ? 'Detailed Response' : 'Response Details'}
        </h3>
      </CardHeader>
      <CardContent className="pt-0">
        <ScrollArea className="h-[400px] w-full rounded-md border p-4">
          {currentDetailedResponse ? (
            <div className="space-y-4">
              <h4 className="text-md font-semibold text-primary">
                {currentDetailedResponse.title}
              </h4>
              <div className="text-sm text-foreground whitespace-pre-line leading-relaxed">
                {phase === 'showing' ? (
                  <span className="text-muted-foreground italic">Preparing detailed response...</span>
                ) : (
                  <>
                    {displayedDetailedText}
                    {isTypingDetailed && <span className="animate-pulse">|</span>}
                  </>
                )}
              </div>
            </div>
          ) : (
            <div className="text-sm text-muted-foreground">
              <p className="mb-2">Short response shown in demo:</p>
              <p className="font-medium">{currentCommandResponse}</p>
              <p className="mt-4 text-xs">
                Detailed responses available for select commands.
              </p>
            </div>
          )}
        </ScrollArea>
      </CardContent>
    </Card>
  );
};

export default DetailedResponsePanel;